import { cognitoApi } from "./api";
import type { PublicationManifest, PublicationRun } from "../types/analytics";

export const publicationsApi = {
  list: async (): Promise<PublicationManifest[]> => {
    const response = await cognitoApi.get<{ publications: PublicationManifest[] }>(
      "/publications"
    );
    return response.data.publications || [];
  },

  get: async (publicationId: number): Promise<PublicationManifest> => {
    const response = await cognitoApi.get<{ publication: PublicationManifest }>(
      `/publications/${publicationId}`
    );
    return response.data.publication;
  },

  create: async (publication: PublicationManifest): Promise<PublicationManifest> => {
    const response = await cognitoApi.post<{ publication: PublicationManifest }>(
      "/publications",
      { publication }
    );
    return response.data.publication;
  },

  update: async (
    publicationId: number,
    publication: PublicationManifest
  ): Promise<PublicationManifest> => {
    const response = await cognitoApi.put<{ publication: PublicationManifest }>(
      `/publications/${publicationId}`,
      { publication }
    );
    return response.data.publication;
  },

  activate: async (publicationId: number): Promise<PublicationManifest> => {
    const response = await cognitoApi.post<{ publication: PublicationManifest }>(
      `/publications/${publicationId}/activate`
    );
    return response.data.publication;
  },

  pause: async (publicationId: number): Promise<PublicationManifest> => {
    const response = await cognitoApi.post<{ publication: PublicationManifest }>(
      `/publications/${publicationId}/pause`
    );
    return response.data.publication;
  },

  remove: async (publicationId: number): Promise<void> => {
    await cognitoApi.delete(`/publications/${publicationId}`);
  },

  listRuns: async (publicationId: number): Promise<PublicationRun[]> => {
    const response = await cognitoApi.get<{ runs: PublicationRun[] }>(
      `/publications/${publicationId}/runs`
    );
    return response.data.runs || [];
  },

  triggerManualRun: async (
    publicationId: number
  ): Promise<{ publication: PublicationManifest; run: PublicationRun }> => {
    const response = await cognitoApi.post<{
      publication: PublicationManifest;
      run: PublicationRun;
    }>(`/publications/${publicationId}/runs/manual`);
    return response.data;
  },
};
